<script setup lang="ts">
import { ButtonVariant } from "@/components/basics/Button.vue";
import { faSparkles } from "@awesome.me/kit-bda1b4ada1/icons/classic/solid";
import { useRouter } from "vue-router";

const Icon = useAsyncComponent(() => import("@/components/basics/Icon.vue"));
const Button = useAsyncComponent(() => import("@/components/basics/Button.vue"));

const router = useRouter();
</script>

<template>
  <div class="bar">
    <Icon :icon="faSparkles" class="bar__icon desktop-only" />
    <p class="bar__text" v-html="$gettext('<strong>Nová verze</strong> webu je k dispozici.')" />
    <Button :variant="ButtonVariant.Secondary" @click="router.go(0)">
      <span class="desktop-only">{{ $gettext("Aktualizovat stránku") }}</span>
      <span class="mobile-only">{{ $gettext("Aktualizovat") }}</span>
    </Button>
  </div>
</template>

<style lang="scss" scoped>
.bar {
  height: var(--notificationBarHeight);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: calc(var(--overlay-z-index) + 2);
  padding: 0 var(--side-padding);
  background-color: var(--green100);
  gap: var(--spacing2x);
  &__icon {
    width: 20px;
    height: 20px;
    color: var(--greenPrimary);
  }
  &__text {
    margin: 0 var(--spacing2x) 0 0;
  }
}
</style>
